import slideToggle from '../../utils/slideToggle.js';

const productPageAccordion = () => {
  const accordions = document.querySelectorAll('.product-accordion__header');
  const shippingInfo = document.querySelector('.shipping-info-trigger');

  accordions.forEach(accordion => {
    accordion.addEventListener('click', function () {
      this.classList.toggle('active');
      const panel = this.nextElementSibling;
      slideToggle(panel, 300);
    });
  });

  if (shippingInfo) {
    shippingInfo.addEventListener('click', function () {
      const shippingInfoContent = document.querySelector('.shipping-info__details');
      slideToggle(shippingInfoContent, 300);
    });
  }

};

export default productPageAccordion;